var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { GEMINI_USAGE_CATEGORIES, GeminiAppNameEnum } from '@workalizer/shared/enums';
import { calculateAverage, getPercentageDiff, randomInt } from '@workalizer/shared/utils';
var DEMO_APPS = [
    GeminiAppNameEnum.GEMINI_APP,
    GeminiAppNameEnum.GMAIL,
    GeminiAppNameEnum.DRIVE,
    GeminiAppNameEnum.DOCS,
    GeminiAppNameEnum.SHEETS,
    GeminiAppNameEnum.SLIDES,
    GeminiAppNameEnum.MEET,
    GeminiAppNameEnum.CHAT
];
var TEAM_USER_COUNT = 8;
var buildRandomCategoryCounts = function () {
    return GEMINI_USAGE_CATEGORIES.reduce(function (acc, category) {
        acc[category] = randomInt(20, 420);
        return acc;
    }, {});
};
var buildSummary = function (withTeam) {
    if (withTeam === void 0) { withTeam = false; }
    return GEMINI_USAGE_CATEGORIES.reduce(function (acc, category) {
        var count = randomInt(120, 980);
        var teamTotal = randomInt(400, 3200);
        acc[category] = __assign({ count: count, share: randomInt(8, 45), previous: getPercentageDiff(randomInt(80, 900), count) }, (withTeam && {
            teamAverage: getPercentageDiff(calculateAverage(teamTotal, TEAM_USER_COUNT), count)
        }));
        return acc;
    }, {});
};
export var geminiUsageCategoryByApp = function (input) {
    var withTeam = Boolean(input.userId);
    return {
        summary: buildSummary(withTeam),
        apps: DEMO_APPS.map(function (appName) { return (__assign({ appName: appName, current: buildRandomCategoryCounts(), previous: buildRandomCategoryCounts() }, (withTeam && { team: buildRandomCategoryCounts() }))); })
    };
};
